module.exports = __webpack_public_path__ + "img/people_bph.e9caca0f.png";